import { useLocalSearchParams } from 'expo-router';
import { WorkoutDetail } from '~/workout/components/workout-detail/WorkoutDetail';

export default function WorkoutEditPage() {
  const { id } = useLocalSearchParams<{ id: string }>();

  return <WorkoutDetail workoutNiceId={id!} />;
}
